var metaUtils = require("../../utiles/metaTypeUtils");
var metaTypeUtils = require("../../utiles/metaTypeUtils");

function getStatus(status){
    switch(status){
        case "INIT":
            return "待处理";
        case "FINISHED":
            return "已完成";
        case "REFUSED":
            return "已拒绝";
        case "CANCELED":
            return "已取消";
        case "NOTHING_TO_DO":
            return "不需要再处理";
        case "APPROVED":
            return "已批准";
        default:
            return status;
    }
}
module.exports = {
    UserTask:[[
        {field: 'owner', title: '{{commonLocal.app.applicant}}',templet:function(res){
            return res.owner?res.owner.code:"";
        }},
        {field: 'taskName', title: '{{commonLocal.app.TaskName}}',},
        {field: 'approveType', title: '{{commonLocal.app.ApprovalType}}',},
        {field: 'status', title: '{{commonLocal.app.state}}',templet:function(res){
            console.log(res)
            return getStatus(res.status);
        }},
        {field: 'action', title: '{{commonLocal.app.operation}}',width:200,templet:function(res){
            switch(res.inheritTypes[0]){
                case metaUtils.metaType.QNAME_USERTASK_EQFAPPROVALFLOW:
                case metaTypeUtils.metaType.QNAME_USERTASK_REGFAPPROVALFLOW:
                    return '<a class="layui-btn layui-btn-primary layui-btn-xs" lay-event="detail">{{commonLocal.app.details}}</a>';
                case metaTypeUtils.metaType.QNAME_USERTASK_EQFLOWFORMPRE:
                case metaTypeUtils.metaType.QNAME_USERTASK_REGFLOWFORMPRE:
                    if(res.status == "CANCELED"||res.status == "FINISHED"){return ""};
                    return '<span><a class="layui-btn layui-btn-normal layui-btn-xs" lay-event="form">{{commonLocal.app.FormFilling}}</a><a class="layui-btn layui-btn-primary layui-btn-xs" lay-event="cancel">{{commonLocal.app.cancel}}</a></span>';
                default:
                    return "";
            }

        }}
    ]],
}



//////////////////
// WEBPACK FOOTER
// ./src/component/userTask/userColumns.js
// module id = 168
// module chunks = 0